module.exports = __webpack_public_path__ + "img/ayun-apps.1a141e49.png";